/**
 * Curated Knowledge Base cross-links.
 * Each "family" groups guides on the same treatment so an overview guide always
 * links to its matching deep-dive (and vice-versa). relatedSlugs() returns the
 * other members of a guide's family.
 */
export const KB_FAMILIES = [
  // Implants: deep-dive <-> overview <-> bone grafting
  [
    'how-long-do-dental-implants-really-last',
    'a-guide-to-dental-implants',
    'a-guide-to-bone-grafting',
  ],
  // Whitening & cosmetic: deep-dive <-> overview <-> bonding/veneers
  [
    'why-do-teeth-whitening-results-fade',
    'a-guide-to-teeth-whitening',
    'a-guide-to-composite-bonding-and-veneers',
  ],
  // Orthodontics: deep-dive <-> overview
  [
    'invisalign-vs-traditional-braces:-which-is-faster',
    'a-guide-to-braces-and-invisalign',
  ],
  // Restorative
  [
    'a-guide-to-dental-crowns-and-onlays',
    'a-guide-to-dental-bridges',
    'a-guide-to-dentures',
    'a-guide-to-white-fillings',
    'a-guide-to-dental-materials',
  ],
  // Gum health
  [
    'a-guide-to-gum-disease',
    'a-guide-to-gum-recession',
    'a-guide-to-gum-grafting',
  ],
  // Oral health & prevention
  [
    'a-guide-to-bad-breath-and-oral-hygiene',
    'a-guide-to-acid-erosion',
    'a-guide-to-night-guards-and-splints',
    'a-guide-to-tmj-and-jaw-pain',
    'a-guide-to-modern-dental-technology',
  ],
];

/** Return up to `limit` other guides from the same treatment family. */
export const relatedSlugs = (slug, limit = 3) => {
  if (!slug) return [];
  const fam = KB_FAMILIES.find((f) => f.includes(slug));
  if (!fam) return [];
  return fam.filter((s) => s !== slug).slice(0, limit);
};
